import{z}from'zod';
import{isEmbeddedRuntime}from'./platform';
import{ModelGiftIntentSchema,mergeModelIntent,parseGiftBrief,type ParsedGiftIntent}from'./intelligence';

const responseSchema=z.object({intent:ModelGiftIntentSchema,source:z.literal('workers_ai'),model:z.string().min(1).max(120)}).strict();
const PROD_ORIGIN='https://seonmulgam.com';
const SENSITIVE_PATTERN=/(?:\b01[016789][ -]?\d{3,4}[ -]?\d{4}\b)|(?:[\w.+-]+@[\w.-]+\.[A-Za-z]{2,})|(?:https?:\/\/)|(?:\b\d{6}[ -]?[1-4]\d{6}\b)|(?:(?<!\d)(?:10|20|30|40|50|60|70|80|90)\s*대(?!\d))/i;

export type InterpretationMode='local'|'ai_assisted'|'local_fallback'|'privacy_fallback';
export type InterpretationResult={intent:ParsedGiftIntent;localIntent:ParsedGiftIntent;mode:InterpretationMode;model?:string};

export const intelligenceEndpoint=()=>import.meta.env.PROD&&isEmbeddedRuntime()?`${PROD_ORIGIN}/api/intelligence`:'/api/intelligence';
export const containsSensitiveBrief=(brief:string)=>SENSITIVE_PATTERN.test(brief.normalize('NFC'));

export async function interpretGiftBrief(brief:string,aiConsent:boolean,fetcher:typeof fetch=fetch):Promise<InterpretationResult>{
 const localIntent=parseGiftBrief(brief);
 if(!aiConsent)return{intent:localIntent,localIntent,mode:'local'};
 if(containsSensitiveBrief(brief))return{intent:localIntent,localIntent,mode:'privacy_fallback'};
 const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),6500);
 try{
  const response=await fetcher(intelligenceEndpoint(),{method:'POST',headers:{'content-type':'application/json'},body:JSON.stringify({brief:brief.trim(),consent:true}),signal:controller.signal});
  if(!response.ok)return{intent:localIntent,localIntent,mode:'local_fallback'};
  const parsed=responseSchema.safeParse(await response.json());
  if(!parsed.success)return{intent:localIntent,localIntent,mode:'local_fallback'};
  return{intent:mergeModelIntent(localIntent,parsed.data.intent),localIntent,mode:'ai_assisted',model:parsed.data.model};
 }catch{return{intent:localIntent,localIntent,mode:'local_fallback'}}finally{clearTimeout(timer)}
}
